import {
    Box,
    Typography,
    Rating,
    Avatar,
    Chip,
} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import { AppSectionView } from 'components/utils/AppSectionView';
import AppCardView from 'components/utils/AppCardView';
import { AppHeroView } from 'components/utils/AppHeroView';
import AppText from 'components/widgets/AppText';

const ReportsPage = () => {

    const performanceMetrics = [
        {
            title: 'Total Deliveries',
            value: '15,000+',
            growth: '+25%',
            icon: <LocalShippingIcon fontSize="large" />,
            description: 'Successfully completed chassis transports'
        },
        {
            title: 'On-Time Delivery',
            value: '99.2%',
            growth: '+5%',
            icon: <AccessTimeIcon fontSize="large" />,
            description: 'Industry-leading punctuality rate'
        },
        {
            title: 'Customer Satisfaction',
            value: '4.8/5',
            growth: '+12%',
            icon: <ThumbUpIcon fontSize="large" />,
            description: 'Based on partner feedback'
        },
        {
            title: 'Safety Rating',
            value: '5/5',
            growth: 'Maintained',
            icon: <VerifiedIcon fontSize="large" />,
            description: 'Perfect safety record maintained'
        }
    ];

    const testimonials = [
        {
            name: 'PPS Motors Pvt Ltd',
            subInfo: 'BhartBenz Authorised Dealer',
            comment: 'We sincerely appreciate AVIS Logistics for their exceptional professionalism and dedication to providing top-tier transportation services. Their commitment to timely delivery and maintaining high standards of efficiency makes them a true leader in the logistics industry.',
            rating: 5,
            image: '/partners/tata.png',
            duration: '9+ months partnership'
        },
        {
            name: 'CARGO MOTORS PRIVATE LIMITED',
            subInfo: 'TATA MOTORS Authorised Dealer',
            comment: "AVIS Logistics exemplifies outstanding customer service in the transportation sector. Their attention to detail, constant communication, and willingness to go the extra mile ensure a stress-free experience for their clients.",
            rating: 5,
            image: '/partners/ashok.png',
            duration: '9+ months partnership'
        },
        {
            name: 'LIBRA AUTOMOBILES LTD.',
            subInfo: 'TATA MOTORS Authorised Dealer',
            comment: "AVIS Logistics' operational excellence is truly unparalleled. Their strategic planning and flawless execution ensure every shipment is handled with utmost care and precision, reflecting their expertise in the logistics domain.",
            image: '/partners/mahindra.png',
            rating: 5,
            duration: '9+ months partnership'
        },
        {
            name: 'SAINI MOTORS COMPANY',
            subInfo: 'TATA Motors Authorised Dealer',
            comment: "We are incredibly grateful to AVIS Logistics for their punctual and seamless transportation services. Their unwavering focus on meeting deadlines without compromising on quality sets them apart in the logistics field.",
            rating: 5,
            image: '/partners/tata.png',
            duration: '9+ months partnership'
        },
        {
            name: 'PASCO MOTORS',
            subInfo: 'TATA MOTORS Authorised Dealer, Ropar',
            comment: "We sincerely appreciate AVIS Logistics for their exceptional transportation services. Their unwavering dedication, professionalism, and focus on customer satisfaction have solidified their role as a trusted and indispensable partner in the logistics industry.",
            rating: 5,
            image: '/partners/ashok.png',
            duration: '9+ months partnership'
        },
        {
            name: 'LIBRA AUTOMOBILES LTD.',
            subInfo: 'TATA MOTORS Authorised Dealer, Chandigarh',
            comment: "AVIS Logistics' operational excellence is truly unparalleled. Their strategic planning and flawless execution ensure every shipment is handled with utmost care and precision, reflecting their expertise in the logistics domain.", 
            rating: 5,
            image: '/partners/mahindra.png',
            duration: '9+ months partnership'
        },

        {
            name: 'KRISHNA AUTO SALES',
            subInfo: 'TATA MOTORS Authorised Dealer',
            comment: "AVIS Logistics has consistently proven to be a reliable partner, ensuring all our transportation needs are met with utmost precision and care. Their ability to handle complex logistics challenges with ease is highly commendable.",
            image: '/partners/mahindra.png',
            rating: 5,
            duration: '9+ months partnership'
        },
        {
            name: 'TATA DLT',
            subInfo: 'Body build',
            comment: "We would like to express our gratitude to AVIS Logistics for their exceptional transportation services. Their unwavering dedication, professionalism, and focus on commitment to customer satisfaction have solidifaction make them an indispensable partner in the logistics industry. We are proud to work with such a reliable and committed team.",
            image: '/partners/mahindra.png',
            rating: 5,
            duration: '9+ months partnership'
        },
    ];

    return (
        <Box>
            {/* Hero Section */}
            <AppHeroView
                title="Performance Reports"
                description="Delivering Excellence in Chassis Transport Solutions" />

            {/* Performance Metrics */}
            <AppSectionView
                title="Yearly performance metrics"
                items={performanceMetrics}
                renderItem={(item) => (
                    <AppCardView
                        sx={{ height: "100%" }}
                        icon={item.icon}
                        title={item.value}
                        description={item.title}
                        footer={<>
                            <Chip
                                label={item.growth}
                                color="success"
                                size="small"
                                icon={<TrendingUpIcon />}
                                sx={{ mb: 2 }}
                            />
                            <Typography variant="body2" color="text.secondary">
                                {item.description}
                            </Typography>
                        </>}
                    />

                )}
            />

            {/* Testimonials */}
            <Box sx={{ bgcolor: "grey.100", p: 2 }}>
                <AppSectionView
                    items={testimonials}
                    title="Partner Testimonials"
                    renderItem={(item, _) => {
                        return <AppCardView
                            icon={<Avatar />}
                            title={item.name}
                            description={item.subInfo}
                            descriptionProps={{ pb: 2, color: "text.secondary" }}
                            header={
                                <FormatQuoteIcon color="primary" fontSize="large" sx={{ position: "absolute", top: 8, right: 8 }} />
                            }
                            footer={
                                <>
                                    <AppText text={item.comment} variant="body2" paragraph textAlign="left" />
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Rating value={item.rating} readOnly />
                                        <Chip label={item.duration} size="small" color="primary" />
                                    </Box>
                                </>
                            }
                            sx={{ height: '100%' }}
                        />
                    }}
                />
            </Box>
        </Box>
    );
};

export default ReportsPage;